import { gql } from '@apollo/client';

export const EXERCISE_FRAGMENT = gql`
  fragment ExerciseFields on Exercice {
      _id
      title
      estimatedTime
      humanReadableId
      shortDescription
      longDescription
      reinforcementMessage
      designSystemColor

  }
`;

export const MY_EXERCISE_FRAGMENT = gql`
  fragment MyExerciseFields on MyExercice {
      _id
      addedOn
      doneToday
      completed
      path{
        _id
      }

  }
`;

export const GET_EXERCISE = gql`
  ${EXERCISE_FRAGMENT}

  query exerciseById($id: String!) {
    exercice(id: $id) {
      ...ExerciseFields
    }
  }
`;

export const GET_MY_EXERCISE_BY_ID = gql`
  ${EXERCISE_FRAGMENT}
  ${MY_EXERCISE_FRAGMENT}
  query retrieveMyExerciceById($id: String!) {
    retrieveMyExerciceById(id: $id) {
      ...MyExerciseFields
      exercice {
        ...ExerciseFields
      }
    }
  }
`;


export const GET_MY_EXERCICES = gql`
  ${EXERCISE_FRAGMENT}
  ${MY_EXERCISE_FRAGMENT}
  query getExercices {
    retrieveActiveOrDoneTodayExercice {
      ...MyExerciseFields
      exercice {
        ...ExerciseFields
      }
    }
  }
`;